import React from "react";
import PropTypes from "prop-types";

const RightArrow = ({ disabled }) => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0306 6.53074L8.53063 11.0307C8.38973 11.1716 8.19863 11.2508 7.99938 11.2508C7.80012 11.2508 7.60902 11.1716 7.46813 11.0307C7.32723 10.8898 7.24807 10.6987 7.24807 10.4995C7.24807 10.3002 7.32723 10.1091 7.46813 9.96824L10.6875 6.75011H1.5C1.30109 6.75011 1.11032 6.67109 0.96967 6.53044C0.829018 6.38979 0.75 6.19902 0.75 6.00011C0.75 5.8012 0.829018 5.61043 0.96967 5.46978C1.11032 5.32913 1.30109 5.25011 1.5 5.25011H10.6875L7.46937 2.03011C7.32848 1.88921 7.24932 1.69812 7.24932 1.49886C7.24932 1.2996 7.32848 1.10851 7.46937 0.967609C7.61027 0.826713 7.80137 0.747559 8.00062 0.747559C8.19988 0.747559 8.39098 0.826713 8.53187 0.967609L13.0319 5.46761C13.1018 5.53738 13.1573 5.62028 13.1951 5.71155C13.2329 5.80281 13.2523 5.90065 13.2522 5.99943C13.252 6.09822 13.2324 6.19601 13.1944 6.28718C13.1564 6.37836 13.1007 6.46113 13.0306 6.53074Z"
        fill={disabled ? "#cbcbcb" : "#111415"}
      />
    </svg>
  );
};

RightArrow.propTypes = {
  disabled: PropTypes.bool,
};

export default RightArrow;
